{
  "name": "ChargeGroup",
  "dbName": "charge_group",
  "columns": [
    {
      "fieldName": "name",
      "dbName": "name",
      "displayName": "Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "description",
      "dbName": "description",
      "displayName": "Description",
      "dataType": "STRING"
    },
    {
      "fieldName": "invoiceHeaderTitle",
      "dbName": "invoice_header_title",
      "displayName": "Invoice Header Title",
      "dataType": "STRING"
    },
    {
      "fieldName": "operationalProcess.name",
      "dbName": "operational_process",
      "displayName": "Operational Process",
      "dataType": "STRING"
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Active",
      "dataType": "BOOLEAN"
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "dbName": "modified_date",
      "displayName": "Modified Date",
      "dataType": "DATETIME"
    }
  ]
}
